import ApiService from '@/services/api.service';

const AppointmentByEmployeeTypeService = {
    getAllAsync(param) {
        const requestData = {
            method: 'get',
            url: "/MdAppointmentByEmployeeType/",
            params: param 
        };
        return ApiService.customRequest(requestData);
    },

    insertAsync(data) {
        return ApiService.post(`/MdAppointmentByEmployeeType`, data);
    },

    deleteAsync(id) {
        return ApiService.delete(`/MdAppointmentByEmployeeType/${id}`);
    }
};

export default AppointmentByEmployeeTypeService;
